import React, { ReactElement } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import { dismissAlert as dismissAlertAction } from "actions/alerts";
import { Dispatch } from "actions/types";
import { State } from "reducers/types";
import { AlertRecord } from "reducers/alerts/reducer";

import Button from "components/Common/Button";
import SvgIcon from "components/Common/SvgIcon";
import { ICON_MAP } from "constants/icons";

import "./style.scss";

interface PropsFromState {
  alert: AlertRecord;
}

interface PropsFromDispatch {
  dismissAlert(): void;
}

type AlertsProps = PropsFromState & PropsFromDispatch;

function Alerts(props: AlertsProps): ReactElement {
  const { alert, dismissAlert } = props;

  return (
    <div className={`Alerts ${alert.isVisible ? "" : "Alerts--hidden"}`}>
      <div className={`
                    Alerts__box
                    ${alert.isVisible ? "" : "Alerts__box--hidden"}
                `}
      >
        <div className="Alerts__box__icon-container">
          {alert.type && (
            <SvgIcon
              icon={ICON_MAP[alert.type].icon}
              fillColor={ICON_MAP[alert.type].color}
              customClassName="Alerts__box__icon-container__icon"
            />
          )}
        </div>
        <div className="Alerts__box__text">
          <div className="Alerts__box__text__message">{alert.message}</div>
          <div className="Alerts__box__text__buttons">
            {alert.buttons && alert.buttons.map(b => (
              <Button
                customClassName="Alerts__box__text__buttons__button"
                onClick={() => b.get("action")()}
                text={b.get("label")}
                title="Open Answer"
                size="small"
                light
                key={b.label}
              />
            ))}
            <Button
              customClassName="Alerts__box__text__buttons__button"
              onClick={dismissAlert}
              text="Dismiss"
              title="Dismiss"
              size="small"
              light
            />
          </div>
        </div>
      </div>
    </div>
  );
}

function mapStateToProps(state: State): PropsFromState {
  const { alert } = state;

  return { alert };
}

function mapDispatchToProps(dispatch: Dispatch): PropsFromDispatch {
  return {
    dismissAlert: bindActionCreators(dismissAlertAction, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Alerts);
